import {
    BrandDTO,
    ChecklistTypeDTO,
    CompanyTypeDTO,
    CompanyTypes,
    CountryLookupDTO,
    DocumentTypeDTO,
    LookupClient_V1,
    LookupTypeDTO,
    SettingDTO,
    StateLookupDTO,
    TermsAndConditionDTO
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';

export default class LookupService {
    private readonly _lookupClient: LookupClient_V1;

    constructor() {
        this._lookupClient = new LookupClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public ApplicationRoles(): Promise<Array<LookupTypeDTO>> {
        return this._lookupClient.roles();
    }

    public ApplicationPermissions(): Promise<Array<LookupTypeDTO>> {
        return this._lookupClient.permissions();
    }

    public Brands(): Promise<Array<BrandDTO>> {
        return this._lookupClient.brands();
    }

    public ChecklistTypes(): Promise<Array<ChecklistTypeDTO>> {
        return this._lookupClient.checklistTypes();
    }

    public CompanyType(): Promise<CompanyTypeDTO> {
        return this._lookupClient.companyType();
    }

    public Countries(): Promise<Array<CountryLookupDTO>> {
        return this._lookupClient.countries();
    }

    public DocumentTypes(): Promise<Array<DocumentTypeDTO>> {
        return this._lookupClient.documentTypes();
    }

    public Settings(): Promise<SettingDTO> {
        return this._lookupClient.settings();
    }

    public States(): Promise<Array<StateLookupDTO>> {
        return this._lookupClient.states();
    }

    public TermsAndConditions(companyType : CompanyTypes): Promise<TermsAndConditionDTO> {
        return this._lookupClient.termsAndConditions(companyType);
    }
}